import {EEquipmentType} from "../models/utils/EEquipmentType";
import {AEquipment} from "../models/equipments/AEquipment";
import {GatewayStandAlone} from "../models/equipments/GatewayStandAlone";
import SpecificationsService from "./storage/distantStorage/SpecificationsService";
import {Streetlight} from "../models/equipments/Streetlight";

class EquipmentService {

    createsEquipmentAccordingToType(equipmentType: EEquipmentType): AEquipment {
        let equipment: AEquipment;
        switch (equipmentType) {
            case EEquipmentType.Gateway:
                equipment = new GatewayStandAlone([], SpecificationsService.SPECS_GW);
                break;
            case EEquipmentType.Streetlight:
                equipment = new Streetlight([], SpecificationsService.SPECS_STREETLIGHT_SEN_2);
                break;
            default:
                equipment = new Streetlight([], SpecificationsService.SPECS_STREETLIGHT_SEN_2);
                break;
        }
        return equipment;
    }


}

export default new EquipmentService();
